/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_RangeInputs */

const en_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Range`)
};

const es_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campo de práctica`)
};

const de_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const zh_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`练习场`)
};

const ar_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ميدان التدريب`)
};

const fr_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const vi_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sân tập`)
};

const sw_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwanja wa mazoezi`)
};

const th_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนามไดร์ฟ`)
};

const bs_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vježbalište`)
};

const ja_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レンジ`)
};

const ko_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`드라이빙 레인지`)
};

const pt_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const it_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving Range`)
};

const sv_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const nl_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const da_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const nb_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const fi_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const pl_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const ru_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Драйвинг-рейндж`)
};

const tr_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const hi_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ड्राइविंग रेंज`)
};

const id_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const ms_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const cs_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const el_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const he_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דרייבינג ריינג'`)
};

const af_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

const hu_nav_range = /** @type {(inputs: Nav_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driving range`)
};

/**
* | output |
* | --- |
* | "Range" |
*
* @param {Nav_RangeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_range = /** @type {((inputs?: Nav_RangeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_RangeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_range(inputs)
	if (locale === "de") return de_nav_range(inputs)
	if (locale === "zh") return zh_nav_range(inputs)
	if (locale === "ar") return ar_nav_range(inputs)
	if (locale === "fr") return fr_nav_range(inputs)
	if (locale === "vi") return vi_nav_range(inputs)
	if (locale === "sw") return sw_nav_range(inputs)
	if (locale === "th") return th_nav_range(inputs)
	if (locale === "bs") return bs_nav_range(inputs)
	if (locale === "ja") return ja_nav_range(inputs)
	if (locale === "ko") return ko_nav_range(inputs)
	if (locale === "pt") return pt_nav_range(inputs)
	if (locale === "it") return it_nav_range(inputs)
	if (locale === "sv") return sv_nav_range(inputs)
	if (locale === "nl") return nl_nav_range(inputs)
	if (locale === "da") return da_nav_range(inputs)
	if (locale === "nb") return nb_nav_range(inputs)
	if (locale === "fi") return fi_nav_range(inputs)
	if (locale === "pl") return pl_nav_range(inputs)
	if (locale === "ru") return ru_nav_range(inputs)
	if (locale === "tr") return tr_nav_range(inputs)
	if (locale === "hi") return hi_nav_range(inputs)
	if (locale === "id") return id_nav_range(inputs)
	if (locale === "ms") return ms_nav_range(inputs)
	if (locale === "cs") return cs_nav_range(inputs)
	if (locale === "el") return el_nav_range(inputs)
	if (locale === "he") return he_nav_range(inputs)
	if (locale === "af") return af_nav_range(inputs)
	if (locale === "hu") return hu_nav_range(inputs)
	return en_nav_range(inputs)
});